import React, { useState } from "react";
import {
  CardWrapper,
  DeleteIcon,
  ThreeDotsContainer,
  UpdateIcon,
} from "./style";
import { FiMoreVertical } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";

export default ({ data, handleUpdate, handleDelete }) => {
  const [threeDotsClicked, setThreeDotsClicked] = useState(false);

  return (
    <CardWrapper>
      {threeDotsClicked && (
        <ThreeDotsContainer
          onMouseOver={() => setThreeDotsClicked(true)}
          onMouseOut={() => setThreeDotsClicked(false)}
        >
          <UpdateIcon onClick={() => handleUpdate(data)}>
            <FiEdit /> Tahrirlash
          </UpdateIcon>
          <DeleteIcon
            onClick={() => {
              handleDelete(data?.id);
            }}
          >
            <FiTrash2 /> O‘chirish
          </DeleteIcon>
        </ThreeDotsContainer>
      )}

      <div className="image-wrapper">
        <img className="img" src={data.photo} alt="" crossOrigin="anonymous" />
        {/* <Image className="ant-image" src={data.photo } preview={false} /> */}
      </div>

      <div className="info-wrapper">
        <button
          className="dotsWrap"
          onClick={() =>
            threeDotsClicked
              ? setThreeDotsClicked(false)
              : setThreeDotsClicked(true)
          }
        >
          <FiMoreVertical viewBox="0 0 8 24" className="three-dots" />
        </button>
        <div className="member-name">
          <div className="slice-text">{data.full_name}</div>
        </div>
        <div className="member-position">
          <div className="slice-text">{data.position}</div>
        </div>
      </div>
    </CardWrapper>
  );
};
